import React, { useEffect, useState } from 'react';
import { fromMobileApp, tryParseJSONObject } from '../config/utils';
import { log, LOG_LEVELS } from '../config/app_logger';

const sentMessageToApp = ({ messageToAppData, setMessageToAppData, setSentToAppMessage }) => {
  if (messageToAppData.sentToAppMessage.length === 0) return;
  const message = messageToAppData.sentToAppMessage[0];
  setSentToAppMessage({ ...message });
  if (window.flutter_inappwebview) {
    try {
      window.flutter_inappwebview.callHandler('bargesMessageHandler', ...[JSON.stringify({ ...message })]);
    } catch (error) {
      // Silently handle errors from Flutter message handler
      log(LOG_LEVELS.ERROR, 'MessageToAppHandler', `Failed to send message via Flutter handler: ${ error }`);
    }
  }
  if (window.bargesMessageHandler && typeof window.bargesMessageHandler.postMessage === 'function') {
    try {
      window.bargesMessageHandler.postMessage(JSON.stringify({ ...message }));
    } catch (error) {
      // Silently handle InvalidAccessError and other postMessage errors
      log(LOG_LEVELS.ERROR, 'MessageToAppHandler', `Failed to send message via bargesMessageHandler: ${ error }`);
    }
  }
  if (window.webkit
    && window.webkit.messageHandlers
    && window.webkit.messageHandlers.bargesMessageHandler
    && typeof window.webkit.messageHandlers.bargesMessageHandler.postMessage === 'function') {
    try {
      window.webkit.messageHandlers.bargesMessageHandler.postMessage(JSON.stringify({ ...message }));
    } catch (error) {
      // Silently handle InvalidAccessError and other postMessage errors
      log(LOG_LEVELS.ERROR, 'MessageToAppHandler', `Failed to send message via webkit message handler: ${ error }`);
    }
  }
  setMessageToAppData({ delete: { ...message } });
};

const setReceivedMessageFromAppHandler = ({ e, setMessageToAppData, setReceivedMessage }) => {
  if (e.origin !== window.location.origin) return;
  const parsedMessage = tryParseJSONObject(e.data);
  if (parsedMessage) {
    setMessageToAppData({ receivedMessageFromApp: parsedMessage });
    setReceivedMessage(parsedMessage);
  }
};

function MessageToAppHandler({
  messageToAppData,
  setMessageToAppData,
  withOutPut = false
}) {
  const [sentToAppMessage, setSentToAppMessage] = useState({});
  const [receivedMessage, setReceivedMessage] = useState({});

  const setReceivedMessageFromApp = (e) => {
    setReceivedMessageFromAppHandler({ e, setMessageToAppData, setReceivedMessage });
  };

  useEffect(() => {
    if (fromMobileApp) {
      window.addEventListener('message', setReceivedMessageFromApp);
      return () => {
        window.removeEventListener('message', setReceivedMessageFromApp);
      };
    }
    return () => {};
  }, []);

  useEffect(() => {
    if (messageToAppData.sentToAppMessage && fromMobileApp) {
      sentMessageToApp({ messageToAppData, setMessageToAppData, setSentToAppMessage });
    }
  }, [messageToAppData.sentToAppMessage]);

  const renderMessadeToApp = () => {
    if (!fromMobileApp || !withOutPut) return null;
    return (
      <div>
        receivedMessage:
        { JSON.stringify(receivedMessage) }
        <br />
        sentToAppMessage:
        { JSON.stringify(sentToAppMessage) }
      </div>
    );
  };

  return renderMessadeToApp();
}

export default MessageToAppHandler;
